import { PORTAL_TUTORIAL_TARGETS } from './portal-tutorial-targets.const'

export const PORTAL_TUTORIAL_NAVBAR_TARGET_BY_URL: Record<string, string> = {
  'service-map': PORTAL_TUTORIAL_TARGETS.SERVICE_MAP,
  grafts: PORTAL_TUTORIAL_TARGETS.GRAFTS,
}
